import { UserProps } from './user';

export const DiffStatesClass: any = {
  normal: 'normal', // normal
  del: 'del', // del
  add: 'add', // add
  master_conflict: 'master-conflict', // master-conflict
  private_conflict: 'private-conflict', // private-conflict
  del_conflict: 'del-conflict' // del-conflict
};

export enum DiffStates {
  NORMAL = 'normal', // normal
  DEL = 'del', // del
  ADD = 'add', // add
  MASTER_CONFLICT = 'master_conflict', // master-conflict
  PRIVATE_CONFLICT = 'private_conflict', // private-conflict
  DEL_CONFLICT = 'del_conflict', // del-conflict

  REVERT = 'revert' // for local use
}

export const VERSION_TAG: any = {
  MASTER: 'master',
  PRIVATE: 'private',
  BRANCH: 'branch'
};

export enum PULL_REQUEST_REVIEW_STATUS {
  APPROVED = 'approved',
  REJECTED = 'rejected',
  PENDING = 'pending',
  MERGED = 'merged',
  CLOSED = 'closed'
}

export interface PullRequest {
  agentId: string;
  userId: string;
  commitId: string;
  masterBase: string;
  reviewStatus: PULL_REQUEST_REVIEW_STATUS;
  reviewedBy: UserProps;
  raisedBy: UserProps;
  upToDate: boolean;
  tag?: string;
  note?: string;
  createDate: string;
}

const parseUser = (data: any) => ({
  user_id: data.user_id,
  nickname: data.nickname
});

export const PRToLocal = (data: any) => ({
  agentId: data.agent_id,
  userId: data.user_id,
  commitId: data.commit_number,
  createDate: data.create_date,
  masterBase: data.master_base,
  reviewStatus: data.review_status,
  reviewedBy: data.reviewed_by && parseUser(data.reviewed_by),
  raisedBy: data.raised_by && parseUser(data.raised_by),
  upToDate: data.up_to_date,
  tag: data.tag,
  note: data.note
});
